export default class ContactModel {
  constructor(contactId, firstName, lastName) {
    this.contactMapId = null
    this.contactId = contactId
    this.firstName = firstName
    this.lastName = lastName
    this.isDefault = false
  }
}
